<template>
  <div :class="computedClasses" data-testid="money-text">
    <span class="money-text__value">
      <slot />
    </span>
    <span class="money-text__placeholder" />
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { useDashStore } from '../../store/DashModule';

@Component
export default class Money extends Vue {
  private readonly dashModule = useDashStore();

  @Prop({ type: Boolean, default: undefined })
  public show?: boolean;

  private get computedClasses() {
    return ['money-text', { 'money-text--hidden': this.isHidden }];
  }

  private get isHidden() {
    const isControlled = this.show !== undefined && this.show !== null;
    return isControlled ? !this.show : !this.dashModule?.showMoney;
  }
}
</script>

<style lang="less" scoped>
.money-text {
  display: inline-block;
  position: relative;

  &.money-text--hidden {
    > .money-text__value {
      visibility: hidden;
    }

    > .money-text__placeholder {
      display: block;
    }
  }
}

.money-text__placeholder {
  position: absolute;
  top: 0;
  left: 0;
  background: @element-disabled;
  border-radius: 4px;
  width: 100%;
  height: 100%;
  display: none;
}
</style>
